export enum NotificationTargetType {
  ALL_USERS = 0,
  BENEFICIARIES = 1,
  PLANS = 2,
}

export const NotificationTargetTypeLabels: Record<NotificationTargetType, string> = {
  [NotificationTargetType.ALL_USERS]: "Todos os usuários",
  [NotificationTargetType.BENEFICIARIES]: "Beneficiário(s)",
  [NotificationTargetType.PLANS]: "Plano(s)",
};

export const NOTIFICATION_TARGET_TYPE_OPTIONS = [
  { value: "0", label: NotificationTargetTypeLabels[NotificationTargetType.ALL_USERS] },
  { value: "1", label: NotificationTargetTypeLabels[NotificationTargetType.BENEFICIARIES] },
  { value: "2", label: NotificationTargetTypeLabels[NotificationTargetType.PLANS] },
];

export default NotificationTargetType;
